import { AdminApi } from 'stylemix-vue-admin'

export default class AirportsApi extends AdminApi {
  constructor(parameters) {
    super('airports', parameters)
  }

  recreateZone(id) {
    return this.submit('post', `/airports/${id}/recreate-zone`, null)
  }
}
